import PptxGenJS from 'pptxgenjs';
import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';
import ISingleMediaSlideData from '@app/types/data/slides/ISingleMediaSlideData';
import {
	createFullScreenCroppedImageForSlide,
	createLogoForSlide,
	createPartnerLogoForSlide
} from '@app/services/export/ppt/utils/layoutUtils';

export default class PowerPointSingleMediaSlideProcessor extends PowerPointSlideProcessor<ISingleMediaSlideData> {
	public async processSlideData(): Promise<void> {
		const slide: PptxGenJS.Slide = this.presentation.addSlide();
		createFullScreenCroppedImageForSlide(slide, this.slideData.image);

		if (this.slideData.logo) {
			createPartnerLogoForSlide(slide, this.slideData.logo);
		}

		createLogoForSlide(slide);
	}
}
